/* ═══════════════════════════════════════════════════════════════
   pdc-designer.js — moteur de rendu du Designer IA (panneaux pub)
   ─────────────────────────────────────────────────────────────────
   Rend en SVG une « proposition » produite par le Worker
   (/apps/designer/generer) : layout + palette + picto + wording.
   Le catalogue (layouts, palettes, pictos) DOIT rester synchronisé
   avec designer-ia/worker/src/schema.js.

   Ordre de chargement : pdc-qrcode.min.js PUIS ce fichier PUIS
   pdc-config.js (on utilise la lib globale `qrcode`).

   API : window.PDC_DESIGNER
     .render(prop, contact, opts)      → chaîne <svg> complète
     .renderInner(prop, contact, opts) → contenu sans balise <svg>
       (pour injection dans l'aperçu #pdc-sv, viewBox 0 0 1200 800)
     opts.watermark : filigrane « APERÇU » (true pour tout affichage
       client ; false UNIQUEMENT pour la maquette atelier)
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var W = 1200, H = 800;

  /* ─── Palettes métier (light = fond clair → encre sur accent = blanc) ─── */
  var PALETTES = {
    'gros-oeuvre': { bg: '#2b2d31', accent: '#f5b700', text: '#ffffff', sub: '#c9cbd1', accentDark: false, light: false },
    'plomberie':   { bg: '#0f4c81', accent: '#5bc2e7', text: '#ffffff', sub: '#bcd9ec', accentDark: false, light: false },
    'elec':        { bg: '#ffd100', accent: '#1a1a1a', text: '#1a1a1a', sub: '#4a4a4a', accentDark: true,  light: true },
    'menuiserie':  { bg: '#f3e9dc', accent: '#5d4037', text: '#3e2c23', sub: '#7a6a5d', accentDark: true,  light: true },
    'paysagiste':  { bg: '#2e5e3a', accent: '#a4d65e', text: '#ffffff', sub: '#cfe6c2', accentDark: false, light: false },
    'peinture':    { bg: '#f5f3f0', accent: '#e64a3b', text: '#26323a', sub: '#5d6b75', accentDark: true,  light: true },
    'renovation':  { bg: '#f7f6f4', accent: '#c8312b', text: '#1d2b50', sub: '#5a6478', accentDark: true,  light: true },
    'carrelage':   { bg: '#2f4858', accent: '#e0a458', text: '#ffffff', sub: '#c2cdd4', accentDark: false, light: false },
    'couverture':  { bg: '#3b4252', accent: '#c34a36', text: '#ffffff', sub: '#c5cad6', accentDark: true,  light: false },
    'terrassement':{ bg: '#2e2a25', accent: '#e87722', text: '#ffffff', sub: '#cfc8bf', accentDark: true,  light: false },
    'forestier':   { bg: '#1f3d2b', accent: '#d9a441', text: '#ffffff', sub: '#c4d2c0', accentDark: false, light: false },
    'nettoyage-toiture':{ bg: '#15545c', accent: '#74d3c8', text: '#ffffff', sub: '#b9dcd9', accentDark: false, light: false },
    'pisciniste':  { bg: '#0277bd', accent: '#ffc62b', text: '#ffffff', sub: '#bfe0f2', accentDark: false, light: false },
    'charpente':   { bg: '#33261b', accent: '#e3a94f', text: '#ffffff', sub: '#d9c9b8', accentDark: false, light: false },
    'transport-terres': { bg: '#2c3540', accent: '#f2a33c', text: '#ffffff', sub: '#c9d2da', accentDark: false, light: false },
    'maitre-oeuvre':{ bg: '#16293d', accent: '#e0a93b', text: '#ffffff', sub: '#c2cfdd', accentDark: false, light: false },
    /* ─── PROTO : palettes VIVES (haut contraste, esprit créa d'agence) ─── */
    'vif-orange-navy': { bg: '#1d2b3a', accent: '#ff6b1a', text: '#ffffff', sub: '#c3d0dd', accentDark: false, light: false, vif: true },
    'vif-rouge-noir':  { bg: '#161616', accent: '#e8281e', text: '#ffffff', sub: '#cfcfcf', accentDark: false, light: false, vif: true },
    'vif-bleu-cyan':   { bg: '#0b1e33', accent: '#00b4ff', text: '#ffffff', sub: '#bcd8ec', accentDark: false, light: false, vif: true },
    'vif-vert-flash':  { bg: '#0f2a1d', accent: '#3ed164', text: '#ffffff', sub: '#c2decb', accentDark: true,  light: false, vif: true },
    'vif-blanc-orange':{ bg: '#f6f4f0', accent: '#ff5a1f', text: '#16202b', sub: '#5a6672', accentDark: true,  light: true,  vif: true }
  };

  /* ─── Pictos métier (viewBox 24) ─── */
  var PICTOS = {
    'gros-oeuvre': function (c) {
      return '<g fill="' + c + '"><rect x="2" y="4" width="9" height="4.6"/><rect x="12.4" y="4" width="9.6" height="4.6"/>' +
        '<rect x="2" y="9.8" width="5" height="4.6"/><rect x="8.4" y="9.8" width="9" height="4.6"/><rect x="18.8" y="9.8" width="3.2" height="4.6"/>' +
        '<rect x="2" y="15.6" width="9" height="4.6"/><rect x="12.4" y="15.6" width="9.6" height="4.6"/></g>';
    },
    'plomberie': function (c) {
      /* tuyau coudé à brides */
      return '<g fill="' + c + '">' +
        '<rect x="6.6" y="2.2" width="8" height="2.6" rx="1"/>' +
        '<rect x="8" y="4.8" width="5.2" height="8.4"/>' +
        '<path d="M8 10.4h8.4a1.4 1.4 0 0 1 1.4 1.4v3.8h-9.8Z" transform="translate(0 -1.4)"/>' +
        '<rect x="12" y="9" width="7.2" height="5.2"/>' +
        '<rect x="19.2" y="7.6" width="2.6" height="8" rx="1"/></g>';
    },
    'elec': function (c) { return '<path fill="' + c + '" d="M13.2 2 4 14.4h6l-1.4 7.6L18 9.6h-6z"/>'; },
    'menuiserie': function (c) {
      return '<g fill="' + c + '"><path d="M3 3h6v12h12v6H3Z"/>' +
        '<rect x="9" y="6" width="3" height="1.8"/><rect x="9" y="10" width="3" height="1.8"/>' +
        '<rect x="13.5" y="12.2" width="1.8" height="3"/><rect x="17.5" y="12.2" width="1.8" height="3"/></g>';
    },
    'paysagiste': function (c) { return '<path fill="' + c + '" d="M3.5 20.5C3.5 11.5 11 3.8 21 3.2c-.8 10.6-8.6 17.6-17.5 17.3Zm2.6-2.4c5-1 9.6-5.4 11.6-11-5.8 1.8-10.2 6-11.6 11Z"/>'; },
    'peinture': function (c) {
      return '<g fill="' + c + '"><rect x="3" y="3" width="15" height="5.4" rx="1"/>' +
        '<path d="M18 4.6h2.4a1.2 1.2 0 0 1 1.2 1.2v3.6a1.2 1.2 0 0 1-1.2 1.2H12.6a1 1 0 0 0-1 1V14h-2v-2.4a2.4 2.4 0 0 1 2.4-2.4h8.6a.4.4 0 0 0 .4-.4V6.2a.4.4 0 0 0-.4-.4H18z"/>' +
        '<rect x="9.6" y="14.4" width="2" height="7" rx=".6"/></g>';
    },
    'renovation': function (c, bgC) {
      return '<g fill="' + c + '"><path d="M12 2.6 2.6 10.6h2.6V21h13.6V10.6h2.6Z"/></g>' +
        '<rect x="9.4" y="13.2" width="5.2" height="5.2" fill="' + (bgC || '#fff') + '"/>';
    },
    'carrelage': function (c) {
      var s = '<g fill="' + c + '">', xs = [2, 8.8, 15.6];
      for (var i = 0; i < 3; i++) for (var j = 0; j < 3; j++) s += '<rect x="' + xs[i] + '" y="' + xs[j] + '" width="6.4" height="6.4"/>';
      return s + '</g>';
    },
    'couverture': function (c) {
      return '<g fill="' + c + '"><path d="M12 2.4 1.6 12l2 2.2L12 6.8l8.4 7.4 2-2.2Z"/>' +
        '<path d="M12 9.4 4.6 16l2 2.2 5.4-4.8 5.4 4.8 2-2.2Z"/></g>';
    },
    'terrassement': function (c) {
      /* pelle mécanique profil : chenilles + cabine + flèche/bras articulé + godet */
      return '<g fill="' + c + '">' +
        '<path d="M4.2 17.2h8.4a2.4 2.4 0 0 1 0 4.8H4.2a2.4 2.4 0 0 1 0-4.8Z"/>' +
        '<path d="M3.4 16.2v-3.4a1 1 0 0 1 1-1h1.4V8.6a1.2 1.2 0 0 1 1.2-1.2h3.6a1.2 1.2 0 0 1 1.2 1.2l.01 3.2h1.7a1 1 0 0 1 1 1v3.4Z"/>' +
        '<path d="M12.8 12.9 17.1 5.4l2.4 1.4-4.3 7.5Z"/>' +
        '<circle cx="18.3" cy="6.4" r="1.6"/>' +
        '<path d="M17.5 5.6l2.3 1.3 1.3 5.4-2.2.9Z"/>' +
        '<path d="M18.8 12.6l3.4.7c.5.1.7.6.5 1l-2.2 3.5c-1.8-.2-3.3-1.6-3.7-3.4Z"/></g>';
    },
    'forestier': function (c) {
      return '<g fill="' + c + '"><path d="M12 2 8 8h2.2L6.6 13h2.4L5 18.6h5.7V22h2.6v-3.4H19L15 13h2.4L13.8 8H16Z"/></g>';
    },
    'nettoyage-toiture': function (c) {
      return '<g fill="' + c + '"><path d="M12 3 2.6 11.4h3L12 6.8l6.4 4.6h3Z"/>' +
        '<path d="M6.6 14.5c0 0-1.7 2.1-1.7 3.2a1.7 1.7 0 0 0 3.4 0c0-1.1-1.7-3.2-1.7-3.2Z"/>' +
        '<path d="M12 15c0 0-1.7 2.1-1.7 3.2a1.7 1.7 0 0 0 3.4 0c0-1.1-1.7-3.2-1.7-3.2Z"/>' +
        '<path d="M17.4 14.5c0 0-1.7 2.1-1.7 3.2a1.7 1.7 0 0 0 3.4 0c0-1.1-1.7-3.2-1.7-3.2Z"/></g>';
    },
    'pisciniste': function (c) {
      /* arceau d'échelle qui plonge dans une grande vague */
      return '<g fill="' + c + '">' +
        '<path d="M12 15.6V8c0-3.2 2.2-5.4 5-5.4s5 2.2 5 5.4v7.6h-2.3V8c0-1.9-1.1-3.1-2.7-3.1S14.3 6.1 14.3 8v7.6Z"/>' +
        '<rect x="14.3" y="8.8" width="5.4" height="1.8" rx=".5"/>' +
        '<rect x="14.3" y="12" width="5.4" height="1.8" rx=".5"/>' +
        '<path d="M2 16.6c1.7 0 1.7 1.8 3.4 1.8s1.7-1.8 3.4-1.8 1.7 1.8 3.4 1.8 1.7-1.8 3.4-1.8 1.7 1.8 3.4 1.8 1.7-1.8 3.4-1.8v2.5c-1.7 0-1.7 1.8-3.4 1.8s-1.7-1.8-3.4-1.8-1.7 1.8-3.4 1.8-1.7-1.8-3.4-1.8-1.7 1.8-3.4 1.8-1.7-1.8-3.4-1.8Z"/></g>';
    },
    'charpente': function (c) {
      /* ferme de charpente : arbalétriers + poinçon + contrefiches + entrait */
      return '<g fill="none" stroke="' + c + '" stroke-width="2.2" stroke-linecap="square" stroke-linejoin="miter">' +
        '<path d="M1.6 17.4 12 6.6 22.4 17.4Z"/>' +
        '<line x1="12" y1="6.6" x2="12" y2="17.4"/>' +
        '<line x1="12" y1="12" x2="6.4" y2="17.4"/>' +
        '<line x1="12" y1="12" x2="17.6" y2="17.4"/></g>' +
        '<rect x="0.8" y="17.2" width="22.4" height="2.3" fill="' + c + '"/>';
    },
    'transport-terres': function (c, bgC) {
      /* camion-benne : benne relevée + cabine vitrée + 3 roues */
      var w = bgC || '#2c3540';
      return '<g fill="' + c + '">' +
        '<path d="M2.2 8.6 13.6 7.4l.6 7.2H3.4Z"/>' +
        '<path d="M15 10h3.6a1 1 0 0 1 .83.44l2.2 3.3a1 1 0 0 1 .17.56v3.3h-6.8Z"/>' +
        '<path d="M16.4 11.3h1.9l1.5 2.3h-3.4Z" fill="' + w + '"/>' +
        '<rect x="2.8" y="15.2" width="18.6" height="1.6"/>' +
        '<circle cx="6.6" cy="18.6" r="2.4"/><circle cx="11" cy="18.6" r="2.4"/><circle cx="17.8" cy="18.6" r="2.4"/>' +
        '<circle cx="6.6" cy="18.6" r=".9" fill="' + w + '"/><circle cx="11" cy="18.6" r=".9" fill="' + w + '"/><circle cx="17.8" cy="18.6" r=".9" fill="' + w + '"/></g>';
    },
    'maitre-oeuvre': function (c, bgC) {
      /* maison + immeuble (de la maison au collectif) — fenêtres découpées couleur de fond */
      var w = bgC || '#16293d';
      var s = '<g fill="' + c + '">' +
        '<path d="M7.2 6.6 1.4 12h1.8v8.4h8V12H13Z"/>' +
        '<path d="M13.4 20.4V3.2a1 1 0 0 1 1-1h6.8a1 1 0 0 1 1 1v17.2Z"/>' +
        '<rect x="1" y="20.4" width="22" height="1.9" rx=".9"/></g><g fill="' + w + '">' +
        '<rect x="5.9" y="15.4" width="2.7" height="5"/>';
      [4.8, 8, 11.2, 14.4].forEach(function (y) { s += '<rect x="15.2" y="' + y + '" width="1.6" height="1.6"/><rect x="17.9" y="' + y + '" width="1.6" height="1.6"/>'; });
      return s + '<rect x="16.3" y="17.6" width="2.4" height="2.8"/></g>';
    }
  };

  var TEL_PATH = 'M6.6 10.8a15.5 15.5 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1.05-.24 11.4 11.4 0 0 0 3.55.57 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1 11.4 11.4 0 0 0 .57 3.55 1 1 0 0 1-.24 1.05Z';

  /* ─── Helpers ─── */
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  var _logoSrc = null; // logo client optionnel (dataURL) — remplace le picto quand fourni
  function picto(key, color, x, y, size, bgColor) {
    if (_logoSrc) {
      var ls = size * 1.6, lx = x + (size - ls) / 2, ly = y + (size - ls) / 2; // agrandi 1,6×, centré sur le slot picto
      return '<image href="' + esc(_logoSrc) + '" x="' + lx + '" y="' + ly + '" width="' + ls + '" height="' + ls + '" preserveAspectRatio="xMidYMid meet"/>';
    }
    if (!key || !PICTOS[key]) return '';
    return '<g transform="translate(' + x + ' ' + y + ') scale(' + (size / 24) + ')">' + PICTOS[key](color, bgColor) + '</g>';
  }
  function telIcon(color, x, y, size) {
    return '<g transform="translate(' + x + ' ' + y + ') scale(' + (size / 24) + ')"><path fill="' + color + '" d="' + TEL_PATH + '"/></g>';
  }
  function fitNom(nom, maxWidth, maxSize) { return Math.min(maxSize, Math.floor(maxWidth / (Math.max(1, nom.length) * 0.82))); }
  function fitLabel(txt, maxWidth, maxSize) { return Math.min(maxSize, Math.floor(maxWidth / (Math.max(1, txt.length) * 0.75))); }

  function telGroup(tel, cx, yBaseline, fontSize, iconColor, textColor) {
    var iconSize = Math.round(fontSize * 0.92), gap = Math.round(fontSize * 0.32);
    var textW = tel.length * fontSize * 0.72;
    var x0 = cx - (iconSize + gap + textW) / 2;
    return telIcon(iconColor, x0, yBaseline - iconSize * 0.82, iconSize) +
      '<text x="' + (x0 + iconSize + gap) + '" y="' + yBaseline + '" fill="' + textColor + '" font-size="' + fontSize + '" font-weight="900" font-family="\'Arial Black\',Arial">' + esc(tel) + '</text>';
  }

  function titreBloc(text, cx, y, dashColor, textColor, maxW) {
    if (!text) return '';
    var fs = fitLabel(text, maxW - 280, 33);
    var w = text.length * fs * 0.78;
    return '<rect x="' + (cx - w / 2 - 140) + '" y="' + (y - fs * 0.36) + '" width="100" height="6" fill="' + dashColor + '"/>' +
      '<rect x="' + (cx + w / 2 + 40) + '" y="' + (y - fs * 0.36) + '" width="100" height="6" fill="' + dashColor + '"/>' +
      '<text x="' + cx + '" y="' + y + '" text-anchor="middle" fill="' + textColor + '" font-size="' + fs + '" font-weight="800" letter-spacing="4">' + esc(text.toUpperCase()) + '</text>';
  }

  /* ─── Pictos par prestation : matcher déterministe libellé → picto métier.
     Front-only (l'IA ne choisit pas) ; fallback = coche. L'ordre des règles compte
     (démoussage avant couverture, charpente avant menuiserie, piscine avant terrassement). ─── */
  var SVC_PICTO_RULES = [
    [/carrel|fa[iï]ence/i, 'carrelage'],
    [/d[ée]mouss|hydrofug|nettoyage/i, 'nettoyage-toiture'],
    [/toitur|couvert|zingu|tuile|ardoise|goutti|[ée]tanch/i, 'couverture'],
    [/charpent|ossature|sur[ée]l[ée]vation/i, 'charpente'],
    [/piscine|\bspa\b/i, 'pisciniste'],
    [/plomb|sanitaire|salle[s]? de bain|salle[s]? d['’ ]?eau|chauffe-eau|robinet/i, 'plomberie'],
    [/[ée]lectr|domotiq|tableau|borne|[ée]clairage/i, 'elec'],
    [/menuiser|fen[êe]tre|porte|volet|agencement|dressing|placard|escalier|cuisine|parquet/i, 'menuiserie'],
    [/pl[âa]tr|placo|cloison|isolation|doublage|faux[- ]plafond/i, 'renovation'],
    [/peintur|enduit|ravalement|papier peint|d[ée]cor/i, 'peinture'],
    [/jardin|paysag|espace[s]? vert|cl[ôo]ture|[ée]lagage|tonte|engazon|arrosage/i, 'paysagiste'],
    [/terrass|\bvrd\b|assainissement|enrochement|d[ée]molition/i, 'terrassement'],
    [/transport|[ée]vacuation|benne/i, 'transport-terres'],
    [/forest|abattage|b[ûu]cheron|d[ée]bardage|bois de chauffage/i, 'forestier'],
    [/ma[çc]on|gros[- ]?[œo]e?uvre|extension|agrandissement|fondation|dalle|b[ée]ton|\bmur/i, 'gros-oeuvre'],
    [/ma[îi]trise d['’ ]?[œo]e?uvre|coordination|bureau d['’ ]?[ée]tude/i, 'maitre-oeuvre'],
    [/r[ée]nov|r[ée]habilit|cl[ée][s]? en main/i, 'renovation']
  ];
  function svcPicto(label) {
    for (var i = 0; i < SVC_PICTO_RULES.length; i++) if (SVC_PICTO_RULES[i][0].test(label)) return SVC_PICTO_RULES[i][1];
    return null;
  }
  var CHECK_PATH = 'M9.55 17.6 4.4 12.45l2.1-2.1 3.05 3.05 7.9-7.9 2.1 2.1Z';

  function servicesList(items, x, y0, p, maxW, maxH) {
    if (!items || !items.length) return '';
    var byCount = items.length <= 3 ? 40 : items.length === 4 ? 36 : items.length === 5 ? 33 : 30;
    var maxLen = 1;
    items.forEach(function (s) { if (s.length > maxLen) maxLen = s.length; });
    var fs = Math.min(byCount, Math.floor((maxW - 40) / (maxLen * 0.62)));
    if (maxH) fs = Math.min(fs, Math.floor(maxH / (items.length * 1.7))); // ne jamais déborder de la zone
    fs = Math.max(fs, 16);
    var lh = Math.round(fs * 1.7), s = '';
    var ps = Math.round(fs * 1.18); // taille du mini-picto de prestation
    items.forEach(function (it, i) {
      var y = y0 + i * lh, key = svcPicto(it);
      var glyph = (key && PICTOS[key]) ? PICTOS[key](p.accent, p.bg) : '<path fill="' + p.accent + '" d="' + CHECK_PATH + '"/>';
      s += '<g transform="translate(' + x + ' ' + (y - ps * 0.78) + ') scale(' + (ps / 24) + ')">' + glyph + '</g>' +
        '<text x="' + (x + ps + 16) + '" y="' + y + '" fill="' + p.text + '" font-size="' + fs + '" font-weight="800">' + esc(it.toUpperCase()) + '</text>';
    });
    return s;
  }

  function badge(text, cx, cy, rot, p) {
    if (!text) return '';
    var fs = 32, w = text.length * fs * 0.72 + 64, h = 70;
    var txtColor = p.light ? '#ffffff' : p.bg;
    return '<g transform="translate(' + cx + ' ' + cy + ') rotate(' + rot + ')">' +
      '<rect x="' + (-w / 2) + '" y="' + (-h / 2) + '" width="' + w + '" height="' + h + '" rx="9" fill="' + p.accent + '"/>' +
      '<text x="0" y="11" text-anchor="middle" fill="' + txtColor + '" font-size="' + fs + '" font-weight="900" font-family="\'Arial Black\',Arial">' + esc(text.toUpperCase()) + '</text></g>';
  }

  function contactLine(d, x, y, color, fs, anchor) {
    var parts = [];
    if (d.ville) parts.push(d.ville + ' et sa région');
    if (d.email) parts.push(d.email);
    if (!parts.length) return '';
    return '<text x="' + x + '" y="' + y + '"' + (anchor ? ' text-anchor="' + anchor + '"' : '') + ' fill="' + color + '" font-size="' + fs + '">' + esc(parts.join('  ·  ')) + '</text>';
  }
  /* version 2 lignes (zones étroites : pas de collision avec la colonne de droite) */
  function contactLines2(d, x, y, color, fs) {
    var s = '', dy = 0;
    if (d.ville) { s += '<text x="' + x + '" y="' + y + '" fill="' + color + '" font-size="' + fs + '">' + esc(d.ville + ' et sa région') + '</text>'; dy = Math.round(fs * 1.4); }
    if (d.email) s += '<text x="' + x + '" y="' + (y + dy) + '" fill="' + color + '" font-size="' + fs + '">' + esc(d.email) + '</text>';
    return s;
  }

  function sloganTxt(text, cx, y, color, fs, anchor) {
    if (!text) return '';
    return '<text x="' + cx + '" y="' + y + '" text-anchor="' + (anchor || 'middle') + '" fill="' + color + '" font-size="' + fs + '" font-style="italic" font-weight="600">' + esc(text) + '</text>';
  }

  /* QR coordonnées : MECARD vectoriel via la lib globale `qrcode` (carte blanche, coins droits) */
  function qrSlot(d, x, y, size) {
    if (!d.qr || typeof qrcode === 'undefined') return '';
    var clean = function (s) { return String(s || '').replace(/[;:\\]/g, ' '); };
    var data = 'MECARD:N:' + clean(d.nom) + ';TEL:' + String(d.tel || '').replace(/[^0-9+]/g, '');
    if (d.email) data += ';EMAIL:' + clean(d.email);
    data += ';;';
    try {
      var q = qrcode(0, 'M');
      q.addData(data);
      q.make();
      var n = q.getModuleCount(), quiet = 2, total = n + quiet * 2, m = size / total, path = '';
      for (var r = 0; r < n; r++) for (var c = 0; c < n; c++) {
        if (q.isDark(r, c)) path += 'M' + (x + (c + quiet) * m).toFixed(2) + ',' + (y + (r + quiet) * m).toFixed(2) + 'h' + m.toFixed(2) + 'v' + m.toFixed(2) + 'h-' + m.toFixed(2) + 'z';
      }
      return '<rect x="' + x + '" y="' + y + '" width="' + size + '" height="' + size + '" fill="#ffffff"/><path d="' + path + '" fill="#000"/>';
    } catch (e) { return ''; }
  }


  /* ─── PROTO : éléments « vifs » ─── */
  /* Coup de brosse irrégulier (vectoriel, imprimable) — x,y = coin haut-gauche, w,h = emprise */
  function brush(x, y, w, h, color, rot) {
    var p = 'M' + (x + w * .03) + ',' + (y + h * .18) +
      ' L' + (x + w * .12) + ',' + (y + h * .02) + ' L' + (x + w * .3) + ',' + (y + h * .1) +
      ' L' + (x + w * .52) + ',' + y + ' L' + (x + w * .74) + ',' + (y + h * .08) +
      ' L' + (x + w * .93) + ',' + (y + h * .02) + ' L' + (x + w) + ',' + (y + h * .3) +
      ' L' + (x + w * .96) + ',' + (y + h * .62) + ' L' + (x + w * .99) + ',' + (y + h * .86) +
      ' L' + (x + w * .8) + ',' + (y + h) + ' L' + (x + w * .55) + ',' + (y + h * .9) +
      ' L' + (x + w * .32) + ',' + (y + h * .98) + ' L' + (x + w * .1) + ',' + (y + h * .88) +
      ' L' + x + ',' + (y + h * .6) + ' Z';
    return '<path d="' + p + '" fill="' + color + '"' + (rot ? ' transform="rotate(' + rot + ' ' + (x + w / 2) + ' ' + (y + h / 2) + ')"' : '') + '/>';
  }
  /* Silhouette métier géante en fond (discrète, vectorielle) */
  function megaPicto(key, color, opacity) {
    if (!key || !PICTOS[key]) return '';
    return '<g opacity="' + (opacity || 0.08) + '" transform="translate(' + (W - 430) + ' ' + (H - 430) + ') scale(17.5)">' + PICTOS[key](color) + '</g>';
  }

  function svgOpen(bg) {
    return '<rect width="' + W + '" height="' + H + '" fill="' + bg + '"/>';
  }

  /* ═══ LAYOUT 1 — CLASSIQUE ENCADRÉ ═══ */
  function classique(d, p) {
    var dh = H - 800;
    var hasSvc = d.services && d.services.length;
    var s = svgOpen(p.bg) +
      (p.vif ? megaPicto(d.pictoKey, p.light ? p.accent : p.text, 0.06) : '') +
      '<rect x="30" y="30" width="' + (W - 60) + '" height="' + (H - 60) + '" fill="none" stroke="' + p.accent + '" stroke-width="7"/>' +
      '<rect x="48" y="48" width="' + (W - 96) + '" height="' + (H - 96) + '" fill="none" stroke="' + p.accent + '" stroke-width="2" opacity=".55"/>';
    s += titreBloc(d.titre, W / 2, 124, p.accent, p.text, 1000);

    if (!hasSvc) {
      var nomSize = fitNom(d.nom, 1000, 96);
      var base = d.titre ? 64 : 0;
      s += picto(d.pictoKey, p.accent, W / 2 - 37, 120 + base, 74, p.bg) +
        '<text x="' + (W / 2) + '" y="' + (248 + base) + '" text-anchor="middle" fill="' + p.accent + '" font-size="33" font-weight="700" letter-spacing="8">' + esc(d.metier.toUpperCase()) + '</text>' +
        '<text x="' + (W / 2) + '" y="' + (270 + base + nomSize) + '" text-anchor="middle" fill="' + p.text + '" font-size="' + nomSize + '" font-weight="900" font-family="\'Arial Black\',Arial">' + esc(d.nom) + '</text>' +
        '<rect x="' + (W / 2 - 90) + '" y="' + (316 + base + nomSize) + '" width="180" height="5" fill="' + p.accent + '"/>' +
        contactLine(d, W / 2, 372 + base + nomSize, p.sub, 30, 'middle');
    } else {
      /* identité à gauche, prestations à droite ; sans badge/slogan le bloc descend pour respirer */
      var ns = fitNom(d.nom, 470, 68);
      var y0 = (d.titre ? 210 : 160) + (!d.badge && !d.slogan ? 40 : 0);
      s += picto(d.pictoKey, p.accent, 84, y0, 66, p.bg) +
        '<text x="84" y="' + (y0 + 78 + ns) + '" fill="' + p.text + '" font-size="' + ns + '" font-weight="900" font-family="\'Arial Black\',Arial">' + esc(d.nom) + '</text>' +
        '<text x="88" y="' + (y0 + 122 + ns) + '" fill="' + p.accent + '" font-size="29" font-weight="700" letter-spacing="2">' + esc(d.metier.toUpperCase()) + '</text>' +
        contactLines2(d, 88, y0 + 164 + ns, p.sub, 25) +
        badge(d.badge, 290, 545 + Math.round(dh / 2), -5, p);
      s += servicesList(d.services, 620, (d.titre ? 248 : 215), p, 480);
    }
    var inkBand = p.light ? '#ffffff' : p.bg;
    var bandCx = d.qr ? 524 : W / 2;
    if (d.slogan) {
      s += '<rect x="30" y="' + (618 + dh) + '" width="' + (W - 60) + '" height="152" fill="' + p.accent + '"/>' +
        telGroup(d.tel, bandCx, 698 + dh, 60, inkBand, inkBand) +
        '<rect x="' + (bandCx - 330) + '" y="' + (716 + dh) + '" width="660" height="2" fill="' + inkBand + '" opacity=".45"/>' +
        sloganTxt(d.slogan, bandCx, 750 + dh, inkBand, 23) +
        qrSlot(d, 1024, 630 + dh, 128);
    } else {
      s += '<rect x="30" y="' + (636 + dh) + '" width="' + (W - 60) + '" height="134" fill="' + p.accent + '"/>' +
        telGroup(d.tel, bandCx, 726 + dh, 72, inkBand, inkBand) +
        qrSlot(d, 1034, 648 + dh, 110);
    }
    return s;
  }

  /* ═══ LAYOUT 2 — BANDEAU DIAGONAL ═══ */
  function diagonal(d, p) {
    var dh = H - 800;
    var hasSvc = d.services && d.services.length;
    var inkOnAccent = p.light ? '#ffffff' : p.bg;
    var s = svgOpen(p.bg) +
      (p.vif ? megaPicto(d.pictoKey, p.light ? p.accent : p.text, 0.07) : '') +
      '<polygon points="0,0 ' + W + ',0 ' + W + ',96 0,224" fill="' + p.accent + '"/>' +
      '<polygon points="0,236 ' + W + ',108 ' + W + ',126 0,254" fill="' + p.accent + '" opacity=".4"/>' +
      picto(d.pictoKey, inkOnAccent, 70, 48, 98, p.accent);

    if (!hasSvc) {
      var nomSize = fitNom(d.nom, 1010, 104);
      s += '<text x="86" y="408" fill="' + p.accent + '" font-size="35" font-weight="700" letter-spacing="7">' + esc((d.titre || d.metier).toUpperCase()) + '</text>' +
        '<text x="80" y="' + (430 + nomSize) + '" fill="' + p.text + '" font-size="' + nomSize + '" font-weight="900" font-family="\'Arial Black\',Arial">' + esc(d.nom) + '</text>' +
        (d.titre ? '<text x="86" y="' + (478 + nomSize) + '" fill="' + p.accent + '" font-size="30" font-weight="700" letter-spacing="3">' + esc(d.metier.toUpperCase()) + '</text>' : '') +
        contactLine(d, 86, (d.titre ? 518 : 486) + nomSize, p.sub, 28);
    } else {
      var ns = fitNom(d.nom, 560, 72);
      s += (d.titre ? '<text x="86" y="330" fill="' + p.accent + '" font-size="26" font-weight="700" letter-spacing="3">' + esc(d.titre.toUpperCase()) + '</text>' : '') +
        '<text x="80" y="' + ((d.titre ? 352 : 330) + ns) + '" fill="' + p.text + '" font-size="' + ns + '" font-weight="900" font-family="\'Arial Black\',Arial">' + esc(d.nom) + '</text>' +
        '<text x="86" y="' + ((d.titre ? 396 : 374) + ns) + '" fill="' + p.accent + '" font-size="28" font-weight="700" letter-spacing="2">' + esc(d.metier.toUpperCase()) + '</text>' +
        contactLines2(d, 86, (d.titre ? 436 : 414) + ns, p.sub, 24) +
        badge(d.badge, 280, 600 + dh, -5, p) +
        servicesList(d.services, 680, 330, p, 450);
    }
    if (p.vif) s += brush(46, 640 + dh, 700, 120, p.accent, -1.5);
    var telInk = p.vif ? (p.light ? '#ffffff' : p.bg) : p.accent;
    var telTxt = p.vif ? (p.light ? '#ffffff' : p.bg) : p.text;
    s += telIcon(telInk, 86, 678 + dh, 56) +
      '<text x="166" y="' + (726 + dh) + '" fill="' + telTxt + '" font-size="62" font-weight="900" font-family="\'Arial Black\',Arial">' + esc(d.tel) + '</text>' +
      sloganTxt(d.slogan, W / 2, 770 + dh, p.sub, 22) +
      qrSlot(d, 1024, 566 + dh, 130) +
      '<rect x="0" y="' + (H - 14) + '" width="' + W + '" height="14" fill="' + p.accent + '"/>';
    return s;
  }

  /* ═══ LAYOUT 3 — SPLIT VERTICAL ═══ */
  function split(d, p) {
    var dh = H - 800;
    var hasSvc = d.services && d.services.length;
    var inkOnAccent = p.light ? '#ffffff' : p.bg;
    var s = svgOpen(p.bg) +
      '<rect x="0" y="0" width="378" height="' + H + '" fill="' + p.accent + '"/>' +
      '<rect x="378" y="0" width="10" height="' + H + '" fill="' + p.accent + '" opacity=".35"/>' +
      picto(d.pictoKey, inkOnAccent, 114, 170, 150, p.accent) +
      '<text x="189" y="' + (d.pictoKey ? 395 : 320) + '" text-anchor="middle" fill="' + inkOnAccent + '" font-size="' + fitLabel(d.metier, 330, 32) + '" font-weight="800" letter-spacing="2">' + esc(d.metier.toUpperCase()) + '</text>' +
      badge(d.badge, 189, 540 + Math.round(dh / 2), -5, p);

    var x0 = 450;
    if (d.titre) s += '<text x="' + (x0 + 4) + '" y="150" fill="' + p.sub + '" font-size="29" font-weight="700" letter-spacing="5">' + esc(d.titre.toUpperCase()) + '</text>';
    var nomSize = fitNom(d.nom, 660, 84);
    var nomY = (d.titre ? 176 : 200) + nomSize;
    s += '<text x="' + x0 + '" y="' + nomY + '" fill="' + p.text + '" font-size="' + nomSize + '" font-weight="900" font-family="\'Arial Black\',Arial">' + esc(d.nom) + '</text>' +
      '<rect x="' + (x0 + 4) + '" y="' + (nomY + 36) + '" width="130" height="5" fill="' + p.accent + '"/>';
    if (hasSvc) s += servicesList(d.services, x0 + 4, nomY + 108, p, 620, (600 + dh) - (nomY + 108) - 16);
    else s += contactLine(d, x0 + 4, nomY + 102, p.sub, 29);

    s += qrSlot(d, 1050, 58, 120) +
      '<rect x="' + x0 + '" y="' + (600 + dh) + '" width="660" height="112" rx="56" fill="none" stroke="' + p.accent + '" stroke-width="5"/>' +
      telGroup(d.tel, x0 + 330, 676 + dh, 54, p.accent, p.text) +
      (hasSvc ? contactLine(d, x0 + 330, 758 + dh, p.sub, 24, 'middle') : sloganTxt(d.slogan, x0 + 330, 758 + dh, p.sub, 23));
    return s;
  }

  /* ═══ LAYOUT 4 — PICTO CENTRAL ═══ */
  function pictoCentral(d, p) {
    var dh = H - 800;
    var hasSvc = d.services && d.services.length;
    var inkOnAccent = p.light ? '#ffffff' : p.bg;
    var s = svgOpen(p.bg);
    if (d.titre) s += titreBloc(d.titre, W / 2, 70, p.accent, p.sub, 900);
    var cy = d.titre ? 196 : 178, r = hasSvc ? 84 : 96;
    s += '<circle cx="' + (W / 2) + '" cy="' + cy + '" r="' + r + '" fill="' + p.accent + '"/>' +
      '<circle cx="' + (W / 2) + '" cy="' + cy + '" r="' + (r + 16) + '" fill="none" stroke="' + p.accent + '" stroke-width="3" opacity=".5"/>' +
      picto(d.pictoKey, inkOnAccent, W / 2 - r * 0.63, cy - r * 0.63, r * 1.26, p.accent);

    var nomSize = fitNom(d.nom, 1000, hasSvc ? 76 : 92);
    var nomY = cy + r + 44 + nomSize * 0.8;
    s += '<text x="' + (W / 2) + '" y="' + nomY + '" text-anchor="middle" fill="' + p.text + '" font-size="' + nomSize + '" font-weight="900" font-family="\'Arial Black\',Arial">' + esc(d.nom) + '</text>' +
      '<text x="' + (W / 2) + '" y="' + (nomY + 52) + '" text-anchor="middle" fill="' + p.accent + '" font-size="33" font-weight="700" letter-spacing="6">' + esc(d.metier.toUpperCase()) + '</text>';

    if (hasSvc) {
      var half = Math.ceil(d.services.length / 2);
      s += servicesList(d.services.slice(0, half), 175, nomY + 108, p, 400) +
        servicesList(d.services.slice(half), 645, nomY + 108, p, 400);
    }
    var pillY = (hasSvc ? 640 : 568) + dh, pillH = hasSvc ? 104 : 118, telFs = hasSvc ? 52 : 58;
    var pillW = Math.round(telFs * 0.92 + telFs * 0.32 + d.tel.length * telFs * 0.72) + 110;
    s += '<rect x="' + (W / 2 - pillW / 2) + '" y="' + pillY + '" width="' + pillW + '" height="' + pillH + '" rx="' + (pillH / 2) + '" fill="' + p.accent + '"/>' +
      telGroup(d.tel, W / 2, pillY + pillH / 2 + 19, telFs, inkOnAccent, inkOnAccent);
    if (!hasSvc) s += contactLine(d, W / 2, 740 + dh, p.sub, 28, 'middle') + sloganTxt(d.slogan, W / 2, 778 + dh, p.sub, 22);
    else s += sloganTxt(d.slogan, W / 2, 778 + dh, p.sub, 22);
    s += qrSlot(d, 1040, 620 + dh, 120);
    return s;
  }

  /* ═══ LAYOUT 5 — MINIMAL ═══ */
  function minimal(d, p) {
    var dh = H - 800;
    var hasSvc = d.services && d.services.length;
    var ink = p.light ? p.text : p.bg;
    var telColor = p.accentDark ? p.accent : ink;
    var s = svgOpen('#ffffff') + '<rect x="0" y="0" width="' + W + '" height="18" fill="' + p.accent + '"/>';
    if (d.titre) s += '<rect x="90" y="108" width="56" height="6" fill="' + p.accent + '"/>' +
      '<text x="166" y="120" fill="#8a8f94" font-size="28" font-weight="700" letter-spacing="6">' + esc(d.titre.toUpperCase()) + '</text>';

    var nomSize = fitNom(d.nom, hasSvc ? 640 : 1020, hasSvc ? 84 : 106);
    var metierY = d.titre ? 230 : 300;
    s += '<text x="90" y="' + metierY + '" fill="#8a8f94" font-size="32" font-weight="600" letter-spacing="7">' + esc(d.metier.toUpperCase()) + '</text>' +
      '<text x="84" y="' + (metierY + 28 + nomSize) + '" fill="' + ink + '" font-size="' + nomSize + '" font-weight="900" font-family="\'Arial Black\',Arial">' + esc(d.nom) + '</text>' +
      '<rect x="90" y="' + (metierY + 70 + nomSize) + '" width="150" height="6" fill="' + p.accent + '"/>';

    if (hasSvc) s += servicesList(d.services, 760, (d.titre ? 240 : 300), { accent: p.accent, text: '#3c4348' }, 380);

    s += contactLine(d, 90, 640 + dh, '#8a8f94', 29) +
      telIcon(telColor, 90, 672 + dh, 58) +
      '<text x="172" y="' + (722 + dh) + '" fill="' + telColor + '" font-size="64" font-weight="900" font-family="\'Arial Black\',Arial">' + esc(d.tel) + '</text>';
    if (d.qr) s += '<rect x="1008" y="' + (554 + dh) + '" width="138" height="138" fill="none" stroke="#d8dadd" stroke-width="2"/>' + qrSlot(d, 1010, 556 + dh, 134) +
      sloganTxt(d.slogan, 90, 770 + dh, '#8a8f94', 22, 'start');
    else s += sloganTxt(d.slogan, 1110, 722 + dh, '#8a8f94', 22, 'end');
    return s;
  }

  var LAYOUTS = { 'classique': classique, 'diagonal': diagonal, 'split': split, 'picto-central': pictoCentral, 'minimal': minimal };

  /* ─── Filigrane APERÇU (double passe noir/blanc → lisible sur tout fond) ─── */
  function watermark() {
    var t = 'APERÇU · panneaux-de-chantier.com', s = '<g pointer-events="none">';
    for (var i = 0; i < 3; i++) for (var j = 0; j < 3; j++) {
      var x = 140 + i * 420, y = 170 + j * Math.round((H - 530) / 2);
      s += '<text x="' + (x + 2) + '" y="' + (y + 2) + '" transform="rotate(-24 ' + x + ' ' + y + ')" font-size="36" font-weight="700" fill="#000" opacity=".10" font-family="Arial">' + t + '</text>' +
        '<text x="' + x + '" y="' + y + '" transform="rotate(-24 ' + x + ' ' + y + ')" font-size="36" font-weight="700" fill="#fff" opacity=".16" font-family="Arial">' + t + '</text>';
    }
    return s + '</g>';
  }

  /* ─── Palette dérivée d'une couleur de logo (accord couleur logo↔panneau) ─── */
  function _h2(v){ v = v < 0 ? 0 : (v > 255 ? 255 : Math.round(v)); return ('0' + v.toString(16)).slice(-2); }
  function _hex(c){ return '#' + _h2(c[0]) + _h2(c[1]) + _h2(c[2]); }
  function paletteFromColor(hex){
    var h = hex.replace('#',''); var r = parseInt(h.substr(0,2),16), g = parseInt(h.substr(2,2),16), b = parseInt(h.substr(4,2),16);
    var L = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    function mix(t, k){ return [r + (t - r) * k, g + (t - g) * k, b + (t - b) * k]; }
    if (L < 0.5) { // fond sombre → accent clair + texte blanc (lisible)
      return { bg: hex, accent: _hex(mix(255, 0.62)), text: '#ffffff', sub: _hex(mix(255, 0.80)), accentDark: false, light: false };
    }
    // fond clair → accent foncé + texte foncé (lisible)
    return { bg: hex, accent: _hex(mix(0, 0.72)), text: _hex(mix(0, 0.84)), sub: _hex(mix(0, 0.52)), accentDark: true, light: true };
  }

  /* ─── API publique ─── */
  function renderInner(prop, contact, opts) {
    opts = opts || {};
    /* ratio d'impression h/w : 2/3 = formats 3:2 (60x40, 90x60, 120x80), 3/4 = 80x60. Défaut 3:2. */
    H = Math.round(W * (opts.ratio || 2 / 3));
    _logoSrc = opts.logo || null; // logo client → remplace le picto le temps du rendu
    var p = (opts.logoColor && /^#[0-9a-fA-F]{6}$/.test(opts.logoColor)) ? paletteFromColor(opts.logoColor) : (PALETTES[prop.palette] || PALETTES['gros-oeuvre']);
    var fn = LAYOUTS[prop.layout] || classique;
    var d = {
      titre: prop.titre || null,
      nom: prop.nom || '',
      metier: prop.metier || '',
      services: prop.services || [],
      ville: prop.ville || null,
      slogan: prop.slogan || null,
      badge: prop.badge || null,
      qr: !!prop.qr,
      // logo fourni → on réserve toujours l'emplacement picto (le logo s'y substitue)
      pictoKey: (prop.picto && prop.picto !== 'aucun') ? prop.picto : (opts.logo ? 'gros-oeuvre' : null),
      tel: (contact && contact.tel) || '',
      email: (contact && contact.email) || null
    };
    var s = fn(d, p);
    _logoSrc = null;
    if (opts.watermark) s += watermark();
    return s;
  }

  function render(prop, contact, opts) {
    var inner = renderInner(prop, contact, opts); /* renderInner fixe H selon opts.ratio */
    return '<svg viewBox="0 0 ' + W + ' ' + H + '" xmlns="http://www.w3.org/2000/svg" font-family="Arial,Helvetica,sans-serif">' +
      inner + '</svg>';
  }

  window.PDC_DESIGNER = { render: render, renderInner: renderInner, PALETTES: PALETTES, W: W, H: H, dims: function () { return { W: W, H: H }; } };
})();
